import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
// import UserInfo from "../../components/Open-pages/user/UserInfo";
// import StaffListings from "../../components/leave-management/staff/StaffListings";
import HelmetWrapper from "../../HelmetWrapper";
import Notifications from "../../components/push-notifications/Notifications";
import WelcomeUser from "../../components/Open-pages/user/WelcomeUser";
import StaffListingsAdmin from "../../components/leave-management/staff/StaffListingsAdmin";

const ApprovalManager = () => {
  const navigate = useNavigate();
  const [pageState, setPageState] = useState(
    JSON.parse(localStorage.getItem("pageState"))
  );
  const { decryptedText: userInfoData, isCustom } = pageState || {};

  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  useEffect(() => {
    const savedState = localStorage.getItem("pageState");

    if (savedState) {
      try {
        setPageState(JSON.parse(savedState));
      } catch (error) {
        console.error("Error parsing saved state:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (!pageState) {
      navigate("/open-access");
    }
  }, [pageState]);

  // const location = useLocation();
  // const { decryptedText: userInfoData, isCustom } = location.state || {};

  return (
    <HelmetWrapper title="WTF: Approval Management">
      <Container
        className="bg-cloud-k px-50px daily-target-metrics-container"
        fluid
      >
        {userInfoData && !isIOS() && <Notifications authData={userInfoData} />}

        <Row>
          <Col>
            {/* <UserInfo userData={userInfoData} /> */}
            <WelcomeUser userName={userInfoData?.name} />
          </Col>
        </Row>

        <Row>
          <Col>
            <StaffListingsAdmin
              userInfoData={userInfoData}
              isOpenPage={isCustom}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default ApprovalManager;
